// extracted by mini-css-extract-plugin
module.exports = {"positionSpinner":"Spinner_positionSpinner__3_DR1"};